module.exports = __webpack_public_path__ + "img/tag_nrv.98d84007.svg";